import React, { Component } from "react";
import { Link } from "react-router-dom";

import { SlideUpDown } from "../../../services/script";
import LogoImage from "../headers/common/logo";
import "./footer-one.css";
import AppStore from "./images/appStore.png";
import GooglePlay from "./images/googlePlay.png";
class FooterOne extends Component {
  componentDidMount() {
    var contentwidth = window.innerWidth;
    if (contentwidth < 750) {
      SlideUpDown("footer-title");
    } else {
      var elems = document.querySelectorAll(".footer-title");
      [].forEach.call(elems, function (elemt) {
        let el = elemt.nextElementSibling;
        el.style = "display: block";
      });
    }
  }

  render() {
    return (
      <footer className="footer-light" style={{ marginTop: 50 }}>
        <section className="section-b-space light-layout">
          <div className="container" style={{ paddingTop: 20 }}>
            <div className="row footer-theme partition-f">
              <div className="col-lg-4 col-md-6">
                <div className="footer-title footer-mobile-title">
                  <h4 style={{ textTransform: "none" }}>About</h4>
                </div>
                <div className="footer-contant">
                  <div
                    className="footer-logo"
                    style={{ maxWidth: "70%", margin: "20px auto" }}
                  >
                    <LogoImage logo={this.props.logoName} />
                  </div>
                  <p>
                    শপিং করুন বিশ্বের যে কোন ই-কমার্স প্লাটফর্ম থেকে খুব সহজে
                    Alg এর সাথে। আমরাই দিচ্ছি সবচেয়ে দ্রুত গতিতে পন্য ডেলিভারি
                    দেওয়ার প্রতিশ্রুতি। ফেসবুক ফ্যান পেজে লাইক দিয়ে আমাদের সাথে
                    থাকুন।
                  </p>
                  <div className="footer-social">
                    <ul>
                      <li>
                        {" "}
                        <a
                          href="https://www.facebook.com/alg.com.bd"
                          target="_blank"
                        >
                          <i className="fa fa-facebook" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/@algshop-c4n"
                          target="_blank"
                        >
                          <i className="fa fa-youtube" aria-hidden="true" />
                        </a>
                      </li>

                      <li>
                        <a
                          href="https://www.instagram.com/alg.com.bd/?igsh=Z3F6OG9sYWZyZGQx#"
                          target="_blank"
                        >
                          <i className="fa fa-instagram" aria-hidden="true" />
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.tiktok.com/@alg.com.bd?_t=ZS-8yB8cXwRsbH&_r=1"
                          target="_blank"
                        >
                          <i aria-hidden="true">ꚠ</i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col offset-xl-1">
                <div className="sub-title">
                  <div className="footer-title">
                    <h4 style={{ textTransform: "none" }}>Why Choose us</h4>
                  </div>
                  <div className="footer-contant">
                    <ul>
                      <li>
                        <Link to={`${process.env.PUBLIC_URL}/pages/about-us`}>
                          About us
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${process.env.PUBLIC_URL}/pages/privacy-policy`}
                        >
                          Privacy Policy
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${process.env.PUBLIC_URL}/pages/refund-policy`}
                        >
                          Return & Refunds
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${process.env.PUBLIC_URL}/pages/terms-and-coditions`}
                        >
                          Terms & conditions
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="sub-title">
                  <div className="footer-title">
                    <h4 style={{ textTransform: "none" }}>Help Center</h4>
                  </div>
                  <div className="footer-contant">
                    <ul>
                      <li>
                        <Link to={`${process.env.PUBLIC_URL}/pages/notices`}>
                          Notices
                        </Link>
                      </li>
                      <li>
                        <Link to={`${process.env.PUBLIC_URL}/pages/faq`}>
                          FAQ
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${process.env.PUBLIC_URL}/pages/how-to-order`}
                        >
                          How to Order
                        </Link>
                      </li>
                      <li>
                        <Link
                          to={`${process.env.PUBLIC_URL}/pages/tax-and-shipping`}
                        >
                          Tax & Shipping
                        </Link>
                      </li>
                      <li>
                        <Link to={`${process.env.PUBLIC_URL}/pages/contact`}>
                          Contact us
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="sub-title">
                  <div className="footer-title">
                    <h4 style={{ textTransform: "none" }}>store information</h4>
                  </div>
                  <div className="footer-contant">
                    <ul className="contact-list">
                      <li>
                        <i className="fa fa-map-marker" />
                        alg.com.bd, <br />
                        85/1 <br />
                        Purana Paltan Lane , <br />
                        Culvert Road,Paltan,
                        <br />
                        Dhaka-1000, Bangladesh
                      </li>
                      <li>
                        <i className="fa fa-phone" />
                        Call Us: +8801823234803
                      </li>
                      <li>
                        <i className="fa fa-envelope-o " />
                        Email Us:{" "}
                        <a href="#" className="style-email">
                          info@alg.com.bd
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="sub-title">
                  <div className="footer-title">
                    <h4 style={{ textTransform: "none" }}>Download App</h4>
                  </div>
                  <div className="footer-contant">
                    <ul className="contact-list">
                      <li>
                        <a href="https://play.google.com" target="_blank">
                          <img src={GooglePlay} style={{ width: "80%" }} />
                        </a>
                      </li>
                      <li>
                        <a href="https://apps.apple.com/us" target="_blank">
                          <img src={AppStore} style={{ width: "80%" }} />
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="sub-footer ">
          <div className="container">
            <div className="row">
              <div className="col-xl-6 col-md-6 col-sm-12">
                <div className="footer-end">
                  <p>
                    <i className="fa fa-copyright" aria-hidden="true" />{" "}
                    2024-2026 alg.com.bd All rights reserved.
                  </p>
                </div>
              </div>

              <div className="col-xl-6 col-md-6 col-sm-12"></div>
            </div>
            <div
              className="row"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
              }}
            >
              {" "}
              <div className="col">
                <div
                  className="footer-end"
                  style={{ paddingBottom: 20, marginTop: -13 }}
                >
                  <a
                    href="https://alglimited.com"
                    target="_blank"
                    style={{ color: "rgb(244, 129, 16)", fontSize: 12 }}
                  >
                    <i className="fa fa-copyright" aria-hidden="true" /> Powered
                    by © ALG Limited
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    );
  }
}

export default FooterOne;
